import React from "react";   
import { ContactReferenceModel } from "../models";
import { CustomLabel, FlexContainer } from "@mindmemobile/mm-shared-global";

type Props = {
  contact: ContactReferenceModel;
};

const RenderContactInfo: React.FC<Props> = ({ contact }) => {
  return (
    <FlexContainer fxLayout="column" spacing={3}>
      <CustomLabel fontSize={"16px"} fontWeight={600}>
        {contact?.fullName}
      </CustomLabel>
      {contact?.email && (
        <CustomLabel fontSize={"12px"} lineHeight="16px">
          {contact?.email}
        </CustomLabel>
      )}
      {(contact?.homePhone?.phoneNumber ||
        contact?.mobilePhone?.phoneNumber ||
        contact?.workPhone?.phoneNumber ||
        contact?.otherPhone?.phoneNumber) && (
        <CustomLabel fontSize={"12px"} lineHeight="16px">
          {contact?.homePhone?.phoneNumber ||
            contact?.mobilePhone?.phoneNumber ||
            contact?.workPhone?.phoneNumber ||
            ""}
        </CustomLabel>
      )}
    </FlexContainer>
  );
};

export default RenderContactInfo;
